<template>
  <div class = "crispy-loader">
    <span class="crispy-loader__ripple"></span>
    <span class="crispy-loader__ripple"></span>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {}
}
</script>

<style scoped lang="scss">
$ripple-size: calc($space-base * 2);

.crispy-loader{
  position: relative;
  display: grid;
  place-items: center;
  width: $ripple-size;
  height: $ripple-size;

  &__ripple {
    position: absolute;
    border: 6px solid $color-surface-primary;
    border-radius: 50%;
    animation: crispy-ripple-animation 1.8s ease-out infinite;

    &:nth-child(2){
      animation-delay: -0.6s;
    }
  }
}

@keyframes crispy-ripple-animation{
  from{
    opacity: 1;
    width: 0;
    height: 0;
  }
  to{
    opacity: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
